<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment/moment";
import { LMap, LTileLayer, LMarker, LPopup, LPolyline} from "@vue-leaflet/vue-leaflet";
import {latLng} from "leaflet";
import L from "leaflet";
import markMap from "@/assets/images/leaflet/map_marker_blue.png";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Cotar Frete Dedicado",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader, LMap, LTileLayer, LMarker, LPopup, LPolyline },
  setup() {

  },
  data() {
    return {
      title: "Cotar Frete Dedicado",
      items: [
        {
          text: "Cotações",
          href: "/cotafrtdeds/listdedicada",
        },
        {
          text: "Cotar Frete Dedicado",
          active: true,
        },
      ],
      showModalOrigem: false,
      empresaData: {},
      userLogged: {},
      updating: true,
      errosValid: null,
      cotacaoData: {
        id: 0,
        status: 'AB',
        numentr: 1,
        numdesc: 1,
      },
      idData: 0,
      submitted: false,
      submittedCotar: false,
      loadingCidOri: false,
      loadingCidDest: false,
      mapMarkersList: [],
      paramsCalc: {
        type_route: 'efficient',
        alternative_routes: 0,
        type_vehicle: 'truck',
        vehicle_axis: 'all',
        table_category: 'all',
        table_axis: 'all',
        freight_load: 'all'
      },
      polylineCoords: null,
      mapObject: null,
      tabelasCalcData: null,
      veiculosData: null,
      visibleOriDest: true,
      userPct: null,

      iconPartida: L.divIcon({
        html: `
          <div style="position: relative; width: 25px; height: 41px;">
            <img src="${markMap}" style="width: 25px; height: 41px;" />
            <span style="
                position: absolute;
                top: 4px; left: 0; width: 100%;
                text-align: center;
                font-size: 16px;
                color: white;
                font-weight: bold;
                text-shadow: 0 0 2px #333;">
                1
            </span>
          </div>
        `,
        className: "",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        shadowSize: [41, 41],
        shadowAnchor: [1, -34],
      }),
      iconDestino: L.divIcon({
        html: `
          <div style="position: relative; width: 25px; height: 41px;">
            <img src="${markMap}" style="width: 25px; height: 41px;" />
            <span style="
                position: absolute;
                top: 4px; left: 0; width: 100%;
                text-align: center;
                font-size: 16px;
                color: white;
                font-weight: bold;
                text-shadow: 0 0 2px #333;">
                2
            </span>
          </div>
        `,
        className: "",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        shadowSize: [41, 41],
        shadowAnchor: [1, -34],
      }),



    };
  },

  computed: {

  },

  methods: {
    latLng,

    upgradePlano(){
      console.log('upgradePlano')
      this.$router.push('/usuario/perfil/' + this.userLogged.id)
    },

    abrirPessoa(pessoaId){
      console.log('abrirPessoa')
      const url = `/cliente/editar/${pessoaId}`
      window.open(url, '_blank')
    },


    cancelarCota() {
      console.log('cancelarCota')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Cancelamento de Cotação",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = false
          api.post(`${getBaseUrl()}api/cotafrtcanc`, {
            iddata: this.idData
          }).then((res) => {
            console.log('then axios')
            console.log(res)
            this.cotacaoData.status = 'CA'
            this.updating = false
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Cotação cancelada com sucesso",
              showConfirmButton: false,
              timer: 1500
            })
          })
        }
      })
    },


    onMapReady(map) {
      this.mapObject = map;
      let latitudeA = null
      let longitudeA = null
      let latitudeB = null
      let longitudeB = null
      if (this.cotacaoData.inicoord && this.cotacaoData.fimcoord) {
        const partesA = this.cotacaoData.inicoord.split(',');
        latitudeA = partesA[0];
        longitudeA = partesA[1];
        const partesB = this.cotacaoData.fimcoord.split(',');
        latitudeB = partesB[0];
        longitudeB = partesB[1];
        if (this.mapObject) {
          const bounds = [
            [latitudeA, longitudeA],
            [latitudeB, longitudeB]
          ];
          this.mapObject.fitBounds(bounds);
        }
      }
    },


    decodePolyline(encoded) {
      let points = [];
      let index = 0, lat = 0, lng = 0;
      while (index < encoded.length) {
        let b, shift = 0, result = 0;
        do {
          b = encoded.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        let dlat = ((result & 1) ? ~(result >> 1) : (result >> 1));
        lat += dlat;
        shift = 0;
        result = 0;
        do {
          b = encoded.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        let dlng = ((result & 1) ? ~(result >> 1) : (result >> 1));
        lng += dlng;
        points.push([lat / 1e5 / 10, lng / 1e5 / 10]);
      }
      return points;
    },


    cotarFrete(){
      console.log('cotarFrete')

      if (this.userPct && this.userPct['consumo'] >= this.userPct['limite']) {

        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Limite de consumo excedido, clique no botão abaixo para upgrade",
          showConfirmButton: true,
        }).then((result) => {
          if (result.value) {
            this.$router.push('/usuario/perfil/' + this.userLogged.id)
          }
        })


      } else {

        this.submittedCotar = true;
        if (this.cotacaoData.cepori && this.cotacaoData.cepdest && this.cotacaoData.cidori && this.cotacaoData.ciddest
            && this.cotacaoData.valorcarga && this.cotacaoData.peso && this.cotacaoData.numentr && this.cotacaoData.numdesc
        ) {
          this.updating = true
          this.errosValid = []
          this.visibleOriDest = false

          // alterar funcao altTipoVeic na cliente-editar
          let restipo = ''
          switch (this.paramsCalc.type_vehicle) {
            case 'CAP':
              restipo = 'car'
              break
            case 'FIV':
              restipo = 'car'
              break
            case 'MOT':
              restipo = 'motorcycle'
              break
            case 'VUC':
              restipo = 'car'
              break
            case 'CT2':
              restipo = 'truck'
              break
            case 'CT3':
              restipo = 'truck'
              break
            case 'CAS':
              restipo = 'truck'
              break
            case 'CAL':
              restipo = 'truck'
              break
            case 'BIT':
              restipo = 'truck'
              break
            default:
              restipo = null
          }
          this.paramsCalc.type_vehicle_parse = restipo


          api.post(`${getBaseUrl()}api/cotafrtded`, {
            cotafrtData: this.cotacaoData,
            paramsCalc: this.paramsCalc
          }).then((res) => {
            console.log('then axios salvar')
            console.log(res)
            if (this.idData === 0) {
              this.idData = res.data[0].id
              this.cotacaoData = res.data[0]
              this.title = `Cotar Frete Dedicado (${this.cotacaoData.id}) ${this.cotacaoData.cidori} - ${this.cotacaoData.ciddest}`
              this.$router.replace('/cotafrtded/editarded/' + this.idData)
            }
            api.post(`${getBaseUrl()}api/cotafrtdedcota`, {
              iddata: this.idData,
              paramsCalc: this.paramsCalc
            }).then((res) => {
              console.log('then axios cotacao')
              console.log(res)
              if (res.data[0] === 'erro') {
                Swal.fire({
                  position: "top-end",
                  icon: "warning",
                  title: "Erro no retorno da cotação",
                  text: res.data[1],
                  showConfirmButton: false,
                  timer: 3500
                })
              } else {
                this.cotacaoData = res.data[0]
                if (res.data[1])
                  this.tabelasCalcData = res.data[1]
                this.parseMarkers()
                if (res.data[2])
                  this.polylineCoords = this.decodePolyline(res.data[2]['polilinha'])
                if (res.data[3])
                  this.veiculosData = res.data[3]
                if (res.data[4])
                  this.userPct = res.data[4]
              }
              this.updating = false
            })
          }).catch((err) => {
            console.log('erro axios')
            // console.log(err)
            // console.log(err.response)
            // console.log(err.response.data.errors)
            let erros = err.response.data.errors
            console.log(erros)
            console.log(typeof erros)
            let listaErros = []
            Object.keys(erros).forEach(key => {
              console.log(key, erros[key]);
              listaErros.push({
                'titulo': key,
                'mensagem': erros[key]
              })
            });
            this.errosValid = listaErros
            this.updating = false
            this.activeTab = 0
          })
        }
      }
    },


    escolherEmprOrigem(emprOrigem){
      console.log('escolherEmprOrigem')
      console.log(emprOrigem)
      if (emprOrigem.cep) {
        this.cotacaoData.cepori = emprOrigem.cep
      }
      if (emprOrigem.bairro) {
        this.cotacaoData.bairroori = emprOrigem.bairro
      }
      if (emprOrigem.compl) {
        this.cotacaoData.complori = emprOrigem.compl
      }
      if (emprOrigem.cidade) {
        this.cotacaoData.cidori = emprOrigem.cidade
      }
      if (emprOrigem.estado) {
        this.cotacaoData.ufori = emprOrigem.estado
      }
      if (emprOrigem.numero) {
        this.cotacaoData.numori = emprOrigem.numero
      }
      if (emprOrigem.rua) {
        this.cotacaoData.logori = emprOrigem.rua
      }
      this.showModalOrigem = false
    },


    informouCepOri() {
      console.log('informouCepOri')
      const cepTratado = this.cotacaoData.cepori.replaceAll('.', '').replaceAll('-', '')
      if (cepTratado.length === 8) {
        this.loadingCidOri = true
        api.get(`${getBaseUrl()}api/conscep`, {
          params: {cep: cepTratado}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          const dataCep = res.data[0]
          this.cotacaoData.cidori = dataCep.localidade
          this.cotacaoData.bairroori = dataCep.bairro
          this.cotacaoData.logori = dataCep.logradouro
          this.cotacaoData.complori = dataCep.complemento
          this.cotacaoData.ufori = dataCep.uf
          //this.cotacaoData.numori = this.nroOrigem === null ? "SN" : this.nroOrigem

          this.loadingCidOri = false
        });
      }
    },


    informouCepDest() {
      console.log('informouCepDest')
      const cepTratado = this.cotacaoData.cepdest.replaceAll('.', '').replaceAll('-', '')
      if (cepTratado.length === 8) {
        this.loadingCidDest = true
        api.get(`${getBaseUrl()}api/conscep`, {
          params: {cep: cepTratado}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          if (res.data[0] === 'erro') {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: "Erro: " + res.data[1],
              showConfirmButton: false,
              timer: 3500
            })
            this.cotacaoData.ciddest = null
            this.cotacaoData.bairrodest = null
            this.cotacaoData.logdest = null
            this.cotacaoData.compldest = null
            this.cotacaoData.ufdest = null
            this.cepinvalido = res.data[0]
          } else {
            const dataCep = res.data[0]
            this.cotacaoData.ciddest = dataCep.localidade
            this.cotacaoData.bairrodest = dataCep.bairro
            this.cotacaoData.logdest = dataCep.logradouro
            this.cotacaoData.compldest = dataCep.complemento
            this.cotacaoData.ufdest = dataCep.uf
            //this.cotacaoData.numdest = this.nroDestino === null ? "SN" : this.nroDestino
          }
          this.loadingCidDest = false
        });
      }
    },


    copiarCotacao() {
      console.log('copiarCotacao')
      this.updating = true
      api.post(`${getBaseUrl()}api/cotafrtcopy`, {
        iddata: this.idData
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.cotacaoData.status = 'AB'
        this.updating = false
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Cotação copiada com sucesso",
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          this.idData = res.data[0].id
          this.$router.replace({path: `/cotafrtded/editarded/${this.idData}`})
          this.carregarDados()
        })
      })
    },


    carregarDados() {
      this.updating = true
      api.get(`${getBaseUrl()}api/cotafrtded`, {
        params: {iddata: this.idData}
      }).then((res) => {
        console.log('then axios cotafrt')
        console.log(res.data)
        this.cotacaoData = res.data[0]
        if (res.data[1])
          this.paramsCalc = res.data[1]
        if (res.data[2])
          this.tabelasCalcData = res.data[2]
        if (res.data[3])
          this.polylineCoords = this.decodePolyline(res.data[3]['polilinha'])
        if (res.data[4]) {
          this.veiculosData = res.data[4]
        }
        if (res.data[5]) {
          this.userPct = res.data[5]
        }
        this.parseMarkers()

        this.idData = this.cotacaoData.id
        this.title = `Cotar Frete Dedicado (${this.cotacaoData.id}) ${this.cotacaoData.cidori} - ${this.cotacaoData.ciddest}`
        this.updating = false
      });
    },


    formSubmit() {
      console.log('formSubmit')
      this.submitted = true;
      if (this.cotacaoData.cepori && this.cotacaoData.cepdest && this.cotacaoData.cidori && this.cotacaoData.ciddest) {
        this.updating = true
        this.errosValid = []
        api.post(`${getBaseUrl()}api/cotafrtded`, {
          cotafrtData: this.cotacaoData,
          paramsCalc: this.paramsCalc
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.updating = false
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          if (this.idData === 0) {
            this.idData = res.data[0].id
            this.cotacaoData = res.data[0]
            this.title = `Cotar Frete (${this.cotacaoData.id}) ${this.cotacaoData.cidori} - ${this.cotacaoData.ciddest}`
            this.$router.replace('/cotafrtded/editarded/' + this.idData)
          }
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })
      }
    },

    parseMarkers(){
      console.log('parseMarkers')
      let latitudeA = null
      let longitudeA = null
      let latitudeB = null
      let longitudeB = null
      this.mapMarkersList = []

      if (this.cotacaoData.inicoord) {
        const partes = this.cotacaoData.inicoord.split(',');
        latitudeA = partes[0];
        longitudeA = partes[1];
        this.mapMarkersList.push({
          'codigo': 'A',
          'endereco': this.cotacaoData.logori,
          'bairro': this.cotacaoData.bairroori,
          'cidade': this.cotacaoData.cidori,
          'estado': this.cotacaoData.ufori,
          'latlong': latLng(latitudeA,longitudeA)
        })
      }

      if (this.cotacaoData.fimcoord) {
        const partes = this.cotacaoData.fimcoord.split(',');
        latitudeB = partes[0];
        longitudeB = partes[1];
        this.mapMarkersList.push({
          'codigo': 'B',
          'endereco': this.cotacaoData.logdest,
          'bairro': this.cotacaoData.bairrodest,
          'cidade': this.cotacaoData.ciddest,
          'estado': this.cotacaoData.ufdest,
          'latlong': latLng(latitudeB,longitudeB)
        })
      }
    },


    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2});
      }
      return "0,00";
    },


  },

  created() {

    this.userLogged = JSON.parse(localStorage.getItem('user'))

  },


  mounted() {
    console.log('mounted_cotafrete_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra) {
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }

    console.log(`idData: ${this.idData}`)
    if (this.idData > 0) {
      this.carregarDados()
    } else {
      this.title = `Criando Nova Cotação Dedicada`
      api.get(`${getBaseUrl()}api/novacotaded`).then((res) => {
        console.log('then axios novacota_ded')
        console.log(res.data)
        if (res.data[0]){
          this.empresaData = res.data[0]
          this.cotacaoData.cepori = this.empresaData.cep
          this.cotacaoData.cidori = this.empresaData.cidade
          this.cotacaoData.numori = this.empresaData.numero
          this.cotacaoData.logori = this.empresaData.rua
          this.cotacaoData.complori = this.empresaData.compl
          this.cotacaoData.bairroori = this.empresaData.bairro
          this.cotacaoData.ufori = this.empresaData.estado
        }
        if (res.data[1]){
          this.paramsCalc = res.data[1]
        }
        if (res.data[2]){
          this.userPct = res.data[2]
        }

        this.updating = false
      });
    }
  },


};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="cotacaoData.status"/>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <b-alert show dismissible
             v-if="userPct && userPct.id > 0 && !updating"
             :variant="userPct.limite - userPct.consumo <= 10 ? 'danger' : userPct.limite - userPct.consumo <= 50 ? 'warning' : 'info'">
      <a class="dropdown-item "
         @click="upgradePlano"
         href="javascript: void(0);">
        <i class="mdi mdi-alert me-2"></i>Plano atual consumindo {{ userPct.consumo }} unidade(s) das {{ userPct.limite }} contratada(s), <span class="text-warning">clique aqui e faça upgrade agora mesmo.<i class="mdi mdi-rocket-launch ms-2"></i> </span>
      </a>
    </b-alert>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`" show dismissible variant="danger">
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <div class="checkout-tabs" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">

<!--              :disabled="cotacaoData.status !== 'AB'"  -->
              <b-button variant="outline-success" class="mx-2" @click="formSubmit"
                        :disabled="false">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar
              </b-button>


<!--              :disabled="cotacaoData.id === 0 || cotacaoData.status === 'CA'"    -->
              <b-button variant="outline-danger" class="mx-2" @click="cancelarCota"
                        :disabled="true">
                <i class="bx bx-block font-size-16 align-middle me-2"></i>
                Cancelar
              </b-button>

              <b-button variant="info" @click="cotarFrete">
                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                Nova Cotação
              </b-button>

              <div class="ms-auto">
                <b-button :disabled="true" variant="outline-secondary" class="mx-2" @click="copiarCotacao">
                  <i class="bx bx-copy font-size-16 align-middle me-2"></i>
                  Copiar
                </b-button>

              </div>

            </div>
          </div>
        </div>
      </div>


      <div class="card" v-if="!updating">
        <div class="card-body">
          <form class="needs-validation" @submit.prevent="formSubmit">
          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-1
                 class="text-dark"
                 href="javascript: void(0);">
                Origem e Destino
              </a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-1" v-model="visibleOriDest" accordion="my-accordion-1" role="tabpanel">
            <b-card-body>

              <div class="row mb-2">
                <div class="col-md-3">
                  <label for="cepori">CEP Origem</label>
                  <div class="position-relative">
                    <input id="cepori" type="text" v-maska="'##.###-###'" v-model="cotacaoData.cepori"
                           class="form-control" @change="informouCepOri"
                           :class="{ 'is-invalid': (submitted || submittedCotar) && !cotacaoData.cepori }" placeholder="CEP Origem"/>
                    <div v-if="(submitted || submittedCotar) && !cotacaoData.cepori" class="invalid-feedback">
                      <span>Campo CEP origem obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <label for="cidori">Cidade Origem</label>
                  <div v-if="!loadingCidOri" class="position-relative">
                    <input id="cidori" type="text" v-model="cotacaoData.cidori"
                           :class="{ 'is-invalid': (submitted || submittedCotar) && !cotacaoData.cidori }" class="form-control"
                           placeholder="Cidade Origem" :disabled="true"/>

                    <div v-if="(submitted || submittedCotar) && !cotacaoData.cidori" class="invalid-feedback">
                      <span>Campo cidade origem obrigatório, favor preencher.</span>
                    </div>
                  </div>

                  <Loader v-if="loadingCidOri" style="min-height: 50px;">
                  </Loader>
                </div>

                <div class="col-md-3">
                  <label for="cepdest">CEP Destino</label>
                  <div v-if="!loadingCidDest" class="position-relative">
                    <input id="cepdest" type="text" v-maska="'##.###-###'" v-model="cotacaoData.cepdest"
                           class="form-control" @change="informouCepDest"
                           :class="{ 'is-invalid': (submitted || submittedCotar) && !cotacaoData.cepdest }" placeholder="CEP Destino"/>
                    <div v-if="(submitted || submittedCotar) && !cotacaoData.cepdest" class="invalid-feedback">
                      <span>Campo CEP destino obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <label for="ciddest">Cidade Destino</label>
                  <div v-if="!loadingCidDest" class="position-relative">
                    <input id="ciddest" type="text" v-model="cotacaoData.ciddest"
                           :class="{ 'is-invalid': submitted && !cotacaoData.ciddest }" class="form-control"
                           placeholder="Cidade Destino" :disabled="true"/>
                    <br>

                    <div v-if="submitted && !cotacaoData.ciddest" class="invalid-feedback">
                      <span>Campo cidade destino obrigatório, favor preencher.</span>
                    </div>
                  </div>
                  <Loader v-if="loadingCidDest" style="min-height: 50px;">
                  </Loader>
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-md-3">
                  <div v-if="!loadingCidOri" class="position-relative">
                    <p class="font-weight-semibold mb-2"> Endereço Origem</p>
                    <div class="d-flex">
                      <div class="col-md-12">
                        <p><span class="font-weight-semibold font-size-12">Logradouro: </span>
                          {{ cotacaoData.logori }} <br>
                          <span class="font-weight-semibold font-size-12">Complemento: </span>
                          {{ cotacaoData.complori }} <br>
                          <span class="font-weight-semibold font-size-12">Bairro: </span> {{ cotacaoData.bairroori }}
                          <br>
                          <span class="font-weight-semibold font-size-12">Cidade/UF: </span> {{ cotacaoData.cidori }} -
                          {{ cotacaoData.ufori }} <br>
                          <span class="font-weight-semibold font-size-12">Cep: </span> {{ cotacaoData.cepori }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div v-if="!loadingCidOri" class="position-relative">
                    <div class="d-flex">
                      <div>
                        <label for="numori" class="font-weight-semibold font-size-12">Número do Endereço Origem: </label>
                        <input id="numori" type="text" size="10" style="font-size: 12px" v-model="cotacaoData.numori"
                               :class="{ 'is-invalid': submitted && !cotacaoData.numori }" class="form-control"
                               placeholder="Número" :disabled="false"/>
                      </div>
                    </div>
                    <div v-if="submitted && !cotacaoData.numori" class="invalid-feedback">
                      <span>Campo cidade origem obrigatório, favor preencher.</span>
                    </div>
                  </div>
                  <Loader v-if="loadingCidOri" style="min-height: 50px;">
                  </Loader>
                </div>

                <div class="col-md-3">
                  <div v-if="!loadingCidDest" class="position-relative">
                    <p class="font-weight-semibold mb-2"> Endereço Destino</p>
                    <div class="d-flex">
                      <div class="col-md-12">
                        <p><span class="font-weight-semibold font-size-12">Logradouro: </span>
                          {{ cotacaoData.logdest }} <br>
                          <span class="font-weight-semibold font-size-12">Complemento: </span>
                          {{ cotacaoData.compldest }} <br>
                          <span class="font-weight-semibold font-size-12">Bairro: </span> {{ cotacaoData.bairrodest }}
                          <br>
                          <span class="font-weight-semibold font-size-12">Cidade/UF: </span> {{ cotacaoData.ciddest }} -
                          {{ cotacaoData.ufdest }} <br>
                          <span class="font-weight-semibold font-size-12">Cep: </span> {{ cotacaoData.cepdest }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div v-if="!loadingCidDest" class="position-relative">
                    <div class="d-flex">
                      <div>
                        <label for="numdest" class="font-weight-semibold font-size-12">Número do Endereço de Destino: </label>
                        <input id="numdest" type="text" size="10" style="font-size: 12px"
                               v-model="cotacaoData.numdest" :class="{ 'is-invalid': submitted && !cotacaoData.ciddest }"
                               class="form-control" placeholder="Número" :disabled="false"/>
                      </div>
                    </div>
                    <div v-if="submitted && !cotacaoData.ciddest" class="invalid-feedback">
                      <span>Campo cidade destino obrigatório, favor preencher.</span>
                    </div>
                  </div>
                  <Loader v-if="loadingCidDest" style="min-height: 50px;">
                  </Loader>
                </div>

              </div>

              <div class="row mb-4">

                <div class="col-sm-2">
                  <label for="valorcarga">Valor Carga</label>
                  <div class="position-relative">
                    <input id="valorcarga"
                           type="number"
                           v-model="cotacaoData.valorcarga"
                           :class="{ 'is-invalid': submittedCotar && !cotacaoData.valorcarga }"
                           class="form-control text-end"
                           placeholder="Valor Carga"/>
                    <div v-if="submittedCotar && !cotacaoData.valorcarga" class="invalid-feedback">
                      <span>Campo valor carga obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-2">
                  <label for="peso">Peso Carga</label>
                  <div class="position-relative">
                    <input id="peso"
                           type="number"
                           v-model="cotacaoData.peso"
                           :class="{ 'is-invalid': submittedCotar && !cotacaoData.peso }"
                           class="form-control text-end"
                           placeholder="Peso Carga"/>
                    <div v-if="submittedCotar && !cotacaoData.peso" class="invalid-feedback">
                      <span>Campo peso carga obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-2">
                  <label for="numentr">Número de Entregas</label>
                  <div class="position-relative">
                    <input id="numentr"
                           type="number"
                           v-model="cotacaoData.numentr"
                           class="form-control text-end"
                           :class="{ 'is-invalid': submittedCotar && !cotacaoData.numentr }"
                           placeholder="Número de Entregas"/>
                    <div v-if="submittedCotar && !cotacaoData.numentr" class="invalid-feedback">
                      <span>Campo número de entregas, favor preencher.</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-2">
                  <label for="numdesc">Número de Descargas</label>
                  <div class="position-relative">
                    <input id="numdesc"
                           type="number"
                           v-model="cotacaoData.numdesc"
                           class="form-control text-end"
                           :class="{ 'is-invalid': submittedCotar && !cotacaoData.numdesc }"
                           placeholder="Número de Descargas"/>
                    <div v-if="submittedCotar && !cotacaoData.numdesc" class="invalid-feedback">
                      <span>Campo número de descargas, favor preencher.</span>
                    </div>
                  </div>
                </div>


                <div class="col-sm-2">
                  <div class="mb-3">
                    <label for="type_vehicle">Tipo Veículo</label>
                    <select
                        id="type_vehicle"
                        v-model="paramsCalc.type_vehicle"
                        class="form-control"
                        :class="{'is-invalid': submittedCotar && !paramsCalc.type_vehicle}">
                      <option value="CAP">Carro de Passeio (Hatch/Sedan)</option>
                      <option value="FIV">Fiorino / Van</option>
                      <option value="MOT">Moto</option>
                      <option value="VUC">VUC (Veículo Urbano de Carga - 3/4)</option>
                      <option value="CT2">Toco (2 eixos)</option>
                      <option value="CT3">Toco (3 eixos)</option>
                      <option value="CAS">Carreta Simples</option>
                      <option value="CAL">Carreta LS (3 eixos)</option>
                      <option value="BIT">Bitrem (7 eixos)</option>
                    </select>
                    <div v-if="submittedCotar && !paramsCalc.type_vehicle" class="invalid-feedback">
                      <span>Campo tipo veículo obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>

              </div>

              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a v-b-toggle.accordion-98
                     class="text-dark"
                     href="javascript: void(0);">
                    Parâmetros Cálculo
                  </a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-98" accordion="my-accordion-98" role="tabpanel">
                <b-card-body>

                  <div class="row mb-2">

                    <div class="col-sm-2">
                      <div class="float-end" style="width: 120px;">
                        <h5 class="font-size-13">Calcular Volta</h5>
                        <div class="d-flex align-items-center justify-content-between" style="margin-top: -12px">
                          <b-form-checkbox
                              switch
                              size="lg"
                              value="S"
                              unchecked-value="N"
                              v-model="paramsCalc.calculate_return">
                            {{ paramsCalc.calculate_return === 'S' ? 'Sim' : 'Não' }}
                          </b-form-checkbox>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-1">
                      <div class="float-end" style="width: 120px;">
                        <h5 class="font-size-13">Otimizar Rota</h5>
                        <div class="d-flex align-items-center justify-content-between" style="margin-top: -12px">
                          <b-form-checkbox
                              switch
                              size="lg"
                              value="S"
                              unchecked-value="N"
                              v-model="paramsCalc.optimized_route">
                            {{ paramsCalc.optimized_route === 'S' ? 'Sim' : 'Não' }}
                          </b-form-checkbox>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-1">
                      <div class="float-end" style="width: 120px;">
                        <h5 class="font-size-13">Otimizar Destino</h5>
                        <div class="d-flex align-items-center justify-content-between" style="margin-top: -12px">
                          <b-form-checkbox
                              switch
                              size="lg"
                              value="S"
                              unchecked-value="N"
                              v-model="paramsCalc.optimized_route_destination ">
                            {{ paramsCalc.optimized_route_destination  === 'S' ? 'Sim' : 'Não' }}
                          </b-form-checkbox>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-1">
                      <div class="float-end" style="width: 120px;">
                        <h5 class="font-size-13">Evitar Locais</h5>
                        <div class="d-flex align-items-center justify-content-between" style="margin-top: -12px">
                          <b-form-checkbox
                              switch
                              size="lg"
                              value="S"
                              unchecked-value="N"
                              v-model="paramsCalc.avoid_locations">
                            {{ paramsCalc.avoid_locations === 'S' ? 'Sim' : 'Não' }}
                          </b-form-checkbox>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <label for="alternative_routes">Rotas Alternativas</label>
                      <div class="position-relative">
                        <input id="alternative_routes"
                               type="number"
                               v-model="paramsCalc.alternative_routes"
                               class="form-control"
                               placeholder="Número de Rotas Alternativas"/>
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <label for="avoid_locations_key">Chave Evitar Locais</label>
                      <div class="position-relative">
                        <input id="avoid_locations_key"
                               type="text"
                               v-model="paramsCalc.avoid_locations_key"
                               class="form-control"
                               placeholder="Número de Rotas Alternativas"/>
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <div class="mb-3">
                        <label for="type_route">Tipo da Rota</label>
                        <select id="type_route" v-model="paramsCalc.type_route" class="form-control"
                                :class="{'is-invalid': submitted && !paramsCalc.type_route}">
                          <option value="efficient">Rota Eficiente</option>
                          <option value="shortest">Rota Curta</option>
                          <option value="avoid_tolls">Evitar Pedágios</option>
                        </select>
                        <div v-if="submitted && !paramsCalc.type_route" class="invalid-feedback">
                          <span>Campo tipo da rota obrigatório, favor selecionar.</span>
                        </div>
                      </div>
                    </div>

                  </div>





                </b-card-body>
              </b-collapse>

            </b-card-body>
          </b-collapse>

          </form>

        </div>
      </div>


      <div class="card" v-if="!updating && tabelasCalcData">
        <div class="card-body">

          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-2
                 class="text-dark"
                 href="javascript: void(0);">
                Detalhes do Cálculo
              </a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-2" visible accordion="my-accordion-2" role="tabpanel">
            <b-card-body>

              <div class="row">

                <div class="col-lg-4">
                  <div class="card blog-stats-wid">
                    <div class="card-body">
                      <div class="d-flex flex-wrap">
                        <div class="me-3">
                          <p class="text-muted mb-2">Início</p>
                          <h5 class="mb-0">{{ cotacaoData.inicio }}</h5>
                        </div>
                        <div class="avatar-sm ms-auto">
                          <div
                              class="avatar-title bg-light rounded-circle text-success font-size-20">
                            <i class="bx bxs-up-arrow-circle"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4">
                  <div class="card blog-stats-wid">
                    <div class="card-body">
                      <div class="d-flex flex-wrap">
                        <div class="me-3">
                          <p class="text-muted mb-2">Fim</p>
                          <h5 class="mb-0">{{ cotacaoData.fim }}</h5>
                        </div>
                        <div class="avatar-sm ms-auto">
                          <div
                              class="avatar-title bg-light rounded-circle text-danger font-size-20">
                            <i class="bx bxs-down-arrow-circle"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-2">
                  <div class="card blog-stats-wid">
                    <div class="card-body">
                      <div class="d-flex flex-wrap">
                        <div class="me-3">
                          <p class="text-muted mb-2">Distância</p>
                          <h5 class="mb-0">{{ cotacaoData.disttx }}</h5>
                        </div>
                        <div class="avatar-sm ms-auto">
                          <div
                              class="avatar-title bg-light rounded-circle text-info font-size-20">
                            <i class="bx bxs-map-alt"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-2">
                  <div class="card blog-stats-wid">
                    <div class="card-body">
                      <div class="d-flex flex-wrap">
                        <div class="me-3">
                          <p class="text-muted mb-2">Duração</p>
                          <h5 class="mb-0">{{ cotacaoData.tempo }}</h5>
                        </div>
                        <div class="avatar-sm ms-auto">
                          <div
                              class="avatar-title bg-light rounded-circle text-warning font-size-20">
                            <i class="bx bxs-time"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>


              <div class="row">

                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a v-b-toggle.accordion-97
                       class="text-dark"
                       href="javascript: void(0);">
                      Composição de Valor
                      <span class="text-danger" v-if="veiculosData && veiculosData.length === 0"> (Nenhum veículo atende ao critério da cotação)</span>
                    </a>

                  </h6>
                </b-card-header>
                <b-collapse id="accordion-97" visible accordion="my-accordion-97" role="tabpanel">
                  <b-card-body>

                    <div class="table-responsive">
                      <table
                          class="table align-middle table-nowrap table-hover mb-0">
                        <thead>
                        <tr>
                          <th scope="col">Transportadora</th>
                          <th scope="col" class="text-end">Valor Base</th>
                          <th scope="col" class="text-end">Adicional (%)</th>
                          <th scope="col" class="text-end">Adicional (R$)</th>
                          <th scope="col" class="text-end">GRIS (%)</th>
                          <th scope="col" class="text-end">Ad.Valorem (%)</th>
                          <th scope="col" class="text-end">Descarga (R$)</th>
                          <th scope="col" class="text-end">Entrega (R$)</th>
                          <th scope="col" class="text-end">Subtotal</th>
                          <th scope="col" class="text-end">ICMS (%)</th>
                          <th scope="col" class="text-end">Pedágio</th>
                          <th scope="col" class="text-end text-black">Valor Total Frete</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in veiculosData" :key="data.id">
                          <td>
                            <a href="javascript: void(0);" class="text-body fw-bold" @click="abrirPessoa(data.pessoa_id)">
                              {{ data.transportadora }}
                              <br />
                              <span class="text-black">{{ data.veiculo }}</span>
                            </a>
                          </td>
                          <td class="text-end">{{ formatDecimal(data.valorbase) }}</td>
                          <td class="text-end">{{ formatDecimal(data.percadic) }}</td>
                          <td class="text-end"> {{ formatDecimal(data.valoradic) }}</td>
                          <td class="text-end"> {{ formatDecimal(data.gris) }}</td>
                          <td class="text-end"> {{ formatDecimal(data.advalorem) }}</td>
                          <td class="text-end"> {{ formatDecimal(data.valordesc) }}</td>
                          <td class="text-end"> {{ formatDecimal(data.valorentr) }}</td>
                          <td class="text-end"> {{ formatDecimal(data.subtotal) }}</td>
                          <td class="text-end"> {{ formatDecimal(data.icms) }}</td>
                          <td class="text-end"> {{ formatDecimal(cotacaoData.pedagio) }}</td>
                          <td class="text-end text-black"> {{ formatDecimal(data.valor) }}</td>

                        </tr>
                        </tbody>
                      </table>
                    </div>

                  </b-card-body>
                </b-collapse>

              </div>

              <div class="row">


                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a v-b-toggle.accordion-99
                       class="text-dark"
                       href="javascript: void(0);">
                      Tabelas de Frete (Origem)
                    </a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-99" accordion="my-accordion-99" role="tabpanel">
                  <b-card-body>

                    <div class="table-responsive">
                      <table
                          class="table align-middle table-nowrap table-hover mb-0">
                        <thead>
                        <tr>
                          <th scope="col"></th>
                          <th scope="col" colspan="2" class="text-center">Granel</th>
                          <th scope="col" colspan="4" class="text-center"></th>
                          <th scope="col" colspan="2" class="text-center">Perigosa Granel</th>
                          <th scope="col" colspan="3" class="text-center">Perigosa</th>
                          <th scope="col" class="text-end">Granel</th>
                        </tr>
                        <tr>
                          <th scope="col">Tabela / Eixo</th>
                          <th scope="col" class="text-end">Sólido</th>
                          <th scope="col" class="text-end">Líquido</th>
                          <th scope="col" class="text-end">Frigorificada</th>
                          <th scope="col" class="text-end">Conteineirizada</th>
                          <th scope="col" class="text-end">Geral</th>
                          <th scope="col" class="text-end">Neogranel</th>
                          <th scope="col" class="text-end">Sólido</th>
                          <th scope="col" class="text-end">Líquido</th>
                          <th scope="col" class="text-end">Frigorificada</th>
                          <th scope="col" class="text-end">Conteineirizada</th>
                          <th scope="col" class="text-end">Geral</th>
                          <th scope="col" class="text-end">Pressurizada</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in tabelasCalcData" :key="data.id">
                          <td>
                            {{ data.tabela_desc }} / {{ data.eixo }}
                          </td>
                          <td class="text-end">
                            {{ formatDecimal(data.granel_solido) }}
                          </td>
                          <td class="text-end">
                            {{ formatDecimal(data.granel_liquido) }}
                          </td>
                          <td class="text-end">
                            {{ formatDecimal(data.frigorificada) }}
                          </td>
                          <td class="text-end">
                            {{ formatDecimal(data.conteineirizada) }}
                          </td>
                          <td class="text-end">
                            {{ formatDecimal(data.geral) }}
                          </td>
                          <td class="text-end">
                            {{ formatDecimal(data.neogranel) }}
                          </td>
                          <td class="text-end">
                            {{ formatDecimal(data.perigosa_granel_solido) }}
                          </td>
                          <td class="text-end">
                            {{ formatDecimal(data.perigosa_granel_liquido) }}
                          </td>
                          <td class="text-end">
                            {{ formatDecimal(data.perigosa_frigorificada) }}
                          </td>
                          <td class="text-end">
                            {{ formatDecimal(data.perigosa_conteineirizada) }}
                          </td>
                          <td class="text-end">
                            {{ formatDecimal(data.perigosa_geral) }}
                          </td>
                          <td class="text-end">
                            {{ formatDecimal(data.granel_pressurizada) }}
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                  </b-card-body>
                </b-collapse>

              </div>

            </b-card-body>
          </b-collapse>

        </div>
      </div>


      <div class="card" v-if="!updating && polylineCoords">
        <div class="card-body">
          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-3
                 class="text-dark"
                 href="javascript: void(0);">
                Mapa
              </a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-3" visible accordion="my-accordion-3" role="tabpanel">
            <b-card-body>
              <l-map
                  ref="mapaPath"
                  @ready="onMapReady"
                  :zoom="5"
                  :options="{zoomSnap: 0.5}"
                  style="height: 400px; width: 100%">
                <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' />
                <l-polyline
                    :lat-lngs="polylineCoords"
                    :color="'#a2c6fe'"
                    :weight="10"
                    :opacity="0.6"
                    :line-cap="'round'"
                    :line-join="'round'"/>
                <l-polyline
                    :lat-lngs="polylineCoords"
                    :color="'#0b60dc'"
                    :weight="2"
                    :opacity="1"
                    :line-cap="'round'"
                    :line-join="'round'"/>
                <l-marker
                    v-for="marker in mapMarkersList" :key="marker.id"
                    :icon="marker.codigo === 'A' ? iconPartida : iconDestino"
                    :lat-lng="marker.latlong">
                  <l-popup>
                    <div>
                      {{ marker.endereco }}
                      <div>
                  <span class="text-black-50">
                    {{marker.bairro}}
                  </span>
                      </div>
                      <router-link :to="`/cliente/detalhe/${marker.id}`" target="_blank" class="text-dark">
                        Código: {{ marker.codigo }}
                      </router-link>
                      <p>
                  <span class="text-black">
                    {{ marker.cidade }}, {{ marker.estado }}
                  </span>
                      </p>
                    </div>
                  </l-popup>
                </l-marker>
              </l-map>
            </b-card-body>
          </b-collapse>
        </div>
      </div>

    </div>


  </Layout>
</template>


<style>

th {
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
}



</style>